<template>
    <v-dialog v-model="loading" persistent fullscreen content-class="loading-dialog">
        <v-container fill-height>
            <v-layout row justify-center align-center>
                <v-progress-circular :size="150"
                                     :width="20"
                                     color="#092D74"
                                     indeterminate>
                </v-progress-circular>
            </v-layout>
        </v-container>
    </v-dialog>
</template>

<script>
    export default {
        props: {
            loading: {
                default: false
            }
        }
    }
</script>

<style>
    .loading-dialog {
        background-color: rgba(1, 1, 1, 0.4);
    }
</style>